// Doc https://material-table.com/#/docs/all-props https://github.com/mbrn/material-table

import React, { Fragment, useState, useEffect } from "react";
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MaterialTable, { MTableToolbar } from "material-table";
import { withStyles } from '@material-ui/core/styles';
import * as H from 'helper';

const Top10TxCountByGame = ({classes, title, source, loading, dataByPmid, dataInGameItemByGame}) => {
    const [geoData, setGeoData] = useState([]);

    useEffect(() => {
        let dataSource = [];
        switch (source) {
          case "ingame-fiat":
            dataSource = dataInGameItemByGame.count.fiat;
            break;
        case "ingame-dep":
            dataSource = dataInGameItemByGame.count.dep;
            break;
        default:
        }
        // let dataSource = source === "auction" ? dataByPmid.count.auction : dataByPmid.count.store;
        let totalNum = _.sumBy(dataSource, data => {
            return data.value;
        });
        let dataArray = [], dataObj = {};
        for (let i=0; i<dataSource.length; i++) {
            dataObj.no = i+1;
            dataObj.title = dataSource[i]['title'];
            dataObj.value = dataSource[i]['value'];
            dataObj.num_ratio = (dataSource[i]['value'] / totalNum * 100).toFixed(2);
            dataArray.push(dataObj);
            dataObj = {};
        }
        setGeoData(dataArray);
    }, [dataByPmid, dataInGameItemByGame]);

    return(
        <MaterialTable
            isLoading={loading.ovByPmid}
            style={{padding: 16, fontSize: 14, minHeight: 280}}
            title={<div style={{fontSize: 18, fontWeight: 500, color: '#000'}}>{title}</div>}
            columns={[
                { title: '#', field: 'no', width: 50, cellStyle: {textAlign:'center'}},
                { title: 'ゲーム', field: 'title', width: 350,
                    render: rowData => <Fragment>
                                            <div style={{display:'flex'}}>
                                                <div style={{paddingTop: 4}}>{rowData.title}</div>
                                            </div>
                                        </Fragment>
                },
                { title: '取引件数', field: 'value', width: 200, type: 'numeric', cellStyle: {textAlign:'center'},
                    render: rowData => <div>{H.FormatNumStrHelper.formatCommaThousand(rowData.value)}</div>},
                { title: '全体比率',field: 'num_ratio', type: 'numeric', cellStyle: {textAlign:'left', marginLeft: 32},
                    render: rowData => <Fragment>
                                            <div style={{display:'flex', height: 16}}>
                                                <div style={{paddingRight: 16, width: 24}}>{rowData.num_ratio}%</div>
                                                <div style={{backgroundColor: '#65C9A5', width:rowData.num_ratio+'%', marginLeft: 20, marginTop:3}}></div>
                                            </div>
                                        </Fragment>
                },
            ]}
            data={geoData}
            options={{
                search: false,
                paging: false,
                sorting: false,
                rowStyle: {
                    textAlign:'center',
                },
                headerStyle: {textAlign:'center'}
            }}
            localization={{
                body: {
                    emptyDataSourceMessage: '表示可能なデータがありません',
                },
            }}
        />
    )
};

Top10TxCountByGame.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = state => ({
    loading: state.nftDepOverview.loading,
    dataByPmid: state.nftDepOverview.dataByPmid,
    dataInGameItemByGame: state.inGameItemSales.dataByGame,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(null, { withTheme: true })(Top10TxCountByGame));
